export const configInsuline = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "Moyenne dose insuline quotidienne - Moyenne répartition Basal/Bolus",
      padding: 20,
    },
    legend: {
      position: "bottom",
    },
    datalabels: {
      align: "top",
      offset: -5,
      backgroundColor: function (context) {
        return "rgb(251,137,26)";
      },
      borderRadius: 4,
      color: "white",
      font: {
        weight: "bold",
      },
      //formatter: Math.round,
      padding: 6,
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: true,
    },
    y: {
      stacked: true,
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      // grid line settings
      grid: {
        drawOnChartArea: true, // only want the grid lines for one axis to show up
      },
    },
  },
};

export const dataConfigInsuline = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "Dose Insuline",
      data: data.diq,
      borderColor: "#FBB41C",
      backgroundColor: "#FBB41C",
      yAxisID: "y1",
      type: "line",
      datalabels: { display: true },
    },
    {
      label: "Basal",
      data: data.basal,
      backgroundColor: "#9FA8D5",
      datalabels: { display: false },
    },
    {
      label: "Bolus",
      data: data.bolus,
      backgroundColor: "#E8D5CC",
      datalabels: { display: false },
    },
  ],
});
